import { useGeoBasedLocale } from './useGeoLocale';

/**
 * Supported languages for the Travel White Label.
 * These correspond to language codes used in the LiteAPI deeplinking documentation:
 * https://docs.liteapi.travel/docs/deeplinking-to-whitelabel#language
 */
export enum NuiteeLanguage {
  en = 'en',
  fr = 'fr',
  ru = 'ru',
  it = 'it',
  nl = 'nl',
  es = 'es',
  tr = 'tr',
  de = 'de',
  ar = 'ar',
  pt = 'pt',
  el = 'el',
  ro = 'ro',
}

/**
 * Hook that returns the appropriate NuiteeLanguage based on the user's geolocation.
 * If the language cannot be determined or is still loading, it defaults to English (`en`).
 *
 * @returns {NuiteeLanguage}
 *   - Valid NuiteeLanguage enum value.
 */
export const useNuiteeLanguage = (): NuiteeLanguage => {
  const { language: localeLanguage } = useGeoBasedLocale();

  const language = localeLanguage as keyof typeof NuiteeLanguage;
  const validLanguage = NuiteeLanguage[language] || NuiteeLanguage.en;

  return validLanguage;
};
